module.exports = __webpack_public_path__ + "img/img_web02_banner1.9c62b84a.jpg";